import { render } from "./WxUserListView.vue?vue&type=template&id=6e4c0e90&scoped=true"
import script from "./WxUserListView.vue?vue&type=script&lang=js"
export * from "./WxUserListView.vue?vue&type=script&lang=js"

import "./WxUserListView.vue?vue&type=style&index=0&id=6e4c0e90&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4c0e90"]])

export default __exports__